<template>
	<main id="home" class="single page main">
		<transition :style="{ '--totalStagger': 2 }" name="slide-in" appear>
			<HomeBanner :style="'--indexStagger: 1'" />
		</transition>

		<transition :style="{ '--totalStagger': 2 }" name="slide-in" appear>
			<PageWrapper :style="'--indexStagger: 2'">
				<ModuleBuilder />
			</PageWrapper>
		</transition>
	</main>
</template>

<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import HomeBanner from '@/components/parts/HomeBanner'
import PageWrapper from '@/components/elements/PageWrapper'

export default {
	name: 'home-page',
	components: {
		ModuleBuilder,
		HomeBanner,
		PageWrapper,
	},
}
</script>
